import request from '@/utils/request';
import { newHost } from '@/global-config';

// eslint-disable-next-line import/prefer-default-export
export function queryDownloadList(data) {
  return request({
    url: '/downloadCenter/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}
